import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { NativeNumberKeyPad } from "@coworker/app/src/components/InputPopup/NativeNumberKeyPad";
import { RegexOptions } from "@coworker/app/src/components/InputPopup/shared/RegexOptions";
import React from "react";
import useTranslation from "../../../../../../packages/locales/translations/util/useTranslation";
import Trans from "../../../../../../packages/locales/translations/util/Trans";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import ExpeditTag from "@coworker/app/src/assets/svg/EXPEDIT-tag.svg?react";
import SupplierNumberMarker from "@coworker/app/src/assets/svg/supplier-number-marker.svg?react";
import styles from "./add-supplier-number-modal.module.css";

interface AddSupplierNumberModalProps {
  supplierNumber: string;
  onSubmit: (newSupplierNumber: string) => void;
  showModal: boolean;
  handleClose: () => void;
}

const CapText = ({ supplierNumber }: { supplierNumber: string }) =>
  supplierNumber.length < SUPPLIER_NUMBER_LENGTH ? (
    <div className={styles["cap-info"]}>
      <Trans values={{ length: SUPPLIER_NUMBER_LENGTH }}>maxNDigits</Trans>
    </div>
  ) : (
    <div className={styles["cap-warning"]}>
      <Trans values={{ length: SUPPLIER_NUMBER_LENGTH }}>
        numberCanOnlyBeNDigits
      </Trans>
    </div>
  );

const SUPPLIER_NUMBER_LENGTH = 5;

export const AddSupplierNumberModal = ({
  showModal,
  handleClose,
  supplierNumber,
  onSubmit,
}: AddSupplierNumberModalProps) => {
  const [supplierNumberInput, setSupplierNumberInput] = React.useState<string>(
    supplierNumber || ""
  );
  const { t } = useTranslation();
  return (
    <FixaModal visible={showModal} handleCloseBtn={handleClose}>
      <FixaSheets
        labelledById="feature-flags-add-new-permission-modal-header"
        alignment="right"
        preserveAlignment={false}
        size="small"
        fullSize
        header={
          <FixaModalHeader
            id="feature-flags-add-new-permission-modal-header"
            title={t("supplierNumberString")}
            floating={false}
          />
        }
        footer={
          <FixaModalFooter>
            <FixaButton
              onClick={() => {
                onSubmit(supplierNumberInput);
              }}
              type="primary"
              fluid
              disabled={supplierNumberInput.length < SUPPLIER_NUMBER_LENGTH}
            >
              {t("confirmString")}
            </FixaButton>
          </FixaModalFooter>
        }
      >
        <FixaModalBody>
          <NativeNumberKeyPad
            keypadType="number"
            inputMode="numeric"
            disabled={false}
            onComplete={() => {
              onSubmit(supplierNumberInput);
            }}
            onUpdate={(updatedValue: string) => {
              setSupplierNumberInput(updatedValue);
            }}
            initialValue={supplierNumberInput}
            maxLength={SUPPLIER_NUMBER_LENGTH}
            regexOptions={RegexOptions.ONLYNUMBERS}
          />
          <CapText supplierNumber={supplierNumberInput} />
          <FixaInlineMessage
            dismissable
            title={t("whereCanIfindSupplierString")}
            variant="informative"
            body={
              <span className={styles["overlay"]}>
                <ExpeditTag />
                <SupplierNumberMarker />
              </span>
            }
          ></FixaInlineMessage>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};
